import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import VehiclePicker from './VehiclePicker';

/**
 * B-02 — Onboarding full-screen vehicle picker (Screen ID: B-02)
 */
const VehiclePickerGate = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.message) {
      toast.info(location.state.message);
    }
  }, [location.state?.message]);

  return <VehiclePicker mode="onboarding" />;
};

export default VehiclePickerGate;
